import { useEffect, useState } from 'react';
import { getDataWithToken, GET_TRACKING_DETAIL_URL } from 'Utils/api';
import Tracking from 'Models/Tracking';

/**
 * Same endpoint and response shape (via the Tracking model) as the existing
 * /tracking screen, so this panel's field names match it one-for-one.
 */
export const useTrackTrip = (tripId) => {
  const [trip, setTrip] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!tripId) return;
    setIsLoaded(false);
    getDataWithToken(GET_TRACKING_DETAIL_URL, { trip_id: tripId })
      .then((response) => {
        console.log('[TripTrackingV2] track response:', response);
        setTrip(new Tracking(response.data));
      })
      .catch((error) => {
        console.log('[TripTrackingV2] track error:', error);
        setTrip(new Tracking({}));
      })
      .finally(() => setIsLoaded(true));
  }, [tripId]);

  return { trip, isLoaded };
};
